import { createApi } from '@reduxjs/toolkit/query/react';

import { setGlobalSettings } from 'store/settings/settingsSlice';

import { logDataDogEvent } from 'utils/datadog';
import { baseQueryWithReauth } from 'utils/services';

import {
  GetGeneralSettingsRes,
  GetSettingsReqProps,
  GetSettingsResProps,
  UpdateSettingsReqProps,
  UpdateSettingsResProps
} from './settings.types';

export const settingsApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getGlobalSettings: build.query<GetGeneralSettingsRes, void>({
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data) {
            dispatch(setGlobalSettings(data));
          }
        } catch (e) {
          logDataDogEvent({
            context: { error: e },
            level: 'error',
            message: 'getGlobalSettings failed'
          });
        }
      },
      query: () => '/settings'
    }),
    getSettings: build.query<GetSettingsResProps, GetSettingsReqProps>({
      keepUnusedDataFor: 0,
      query: () => 'notifications/settings'
    }),
    updateSettings: build.mutation<UpdateSettingsResProps, UpdateSettingsReqProps>({
      query: (body) => ({
        body,
        method: 'PATCH',
        url: '/notifications/settings'
      })
    })
  }),
  reducerPath: 'settingsApi',
  tagTypes: ['Settings']
});

export const { useGetSettingsQuery, useUpdateSettingsMutation } = settingsApi;
